import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const dateRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const start = group.get('startContractDate')?.value;
  const end = group.get('endContractDate')?.value;

  if (!start && !end) return null; // both empty = valid

  if (start && !end) return { endRequired: true };
  if (!start && end) return { startRequired: true };

  if (new Date(start) > new Date(end)) return { invalidRange: true };

  return null;
};
